import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {Box, Button, ClickAwayListener, InputAdornment, Popper, TextField, useMediaQuery} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SearchTrending from './SearchTrending';

interface SearchInputProps {
    searchInput?: string;
    updateSearchInput?: (searchInput: string) => void;
}


const SearchInput = (props:SearchInputProps): JSX.Element => {
  
    useEffect(() => {   
        setSearchInput(props.searchInput || '');
    }, [props.searchInput]);

    const location = useLocation();
    const theme = useTheme();
    const [searchInput, setSearchInput] = useState<string>(props.searchInput || '');
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [openTreanding, setTrendingOpen] = useState(false);
    
    const displaySearchTrending = window.location.pathname.toLocaleLowerCase().includes('search') ? false : true;
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

   
     const changeSearchInput = (event: any) => {
         showSearchTrending(event);
         setSearchInput(event.target.value);
         setTrendingOpen(false);
    };

    

    const showSearchTrending = (event: any) => {
        if(!displaySearchTrending) return;
        if(!isMd) return;
        setAnchorEl(event.currentTarget);
        setTrendingOpen(true);
    }

    const hideSearchTrending = () => {
        setTrendingOpen(false);
        setAnchorEl(null);
    }

     const updateSearchInput = () => {
        if (props.updateSearchInput) {
            props.updateSearchInput(searchInput);
        }
        let pathname = location.pathname; 
        if(pathname !== '/Search'){
            window.location.href = '/Search?q=' + searchInput;
        }
     }

     const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            updateSearchInput();
        }
      };

    return (
    <>
        <Box display="flex" alignItems={'center'} onMouseLeave={hideSearchTrending} sx={{ width: '100%' }} >
            <Box width={1} marginRight={1}>
            <TextField
                sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                    border: '0 !important',
                },
                
                }}
                variant="outlined"
                color="primary"
                size="medium"
                placeholder="Search ocpf.us or ask a question"
                defaultValue={props.searchInput}
                value={searchInput}
                onChange={changeSearchInput}
                onMouseEnter={showSearchTrending}
                fullWidth
                onKeyDown={handleKeyDown}
                slotProps={{
                    input:{
                        startAdornment: 
                        <InputAdornment position="start">
                            <SearchIcon 
                                color="primary" 
                                fontSize='large'
                            >
                            </SearchIcon>
                        </InputAdornment>
                    },
                }}
            />
            </Box>
            <Box>
                <Button
                    sx={{ height: 34, minWidth: 75, whiteSpace: 'nowrap' }}
                    variant="contained"
                    color="primary"
                    size="medium"
                    fullWidth
                    onClick={updateSearchInput}
                >
                Search
                </Button>
            </Box>
            <ClickAwayListener onClickAway={hideSearchTrending}>
                <Popper
                    open={openTreanding}
                    anchorEl={anchorEl}
                    placement={"bottom-start"}
                    sx={{width: '500px'}}
                >
                    <Box sx={{ p:1, width: '100%'}}>
                        <SearchTrending></SearchTrending>
                    </Box>
                </Popper>
            </ClickAwayListener>
        </Box>
    </>
    );
};

export default SearchInput;
